import { render, staticRenderFns } from "./KomerceBalance.vue?vue&type=template&id=5b1920d3&"
import script from "./KomerceBalance.vue?vue&type=script&lang=js&"
export * from "./KomerceBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports